import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import patchRequest from "util/APIHelperPatch";

/**
 * Get employee timesheet data
 * @param {string} userId - The employee user ID
 * @param {object} params - Query parameters
 * @param {string} params.startDate - Start date in YYYY-MM-DD format
 * @param {string} params.endDate - End date in YYYY-MM-DD format
 * @param {boolean} params.filterMissedShiftsOnly - Optional filter for missed shifts only
 * @param {number} params.page - Page number (1-indexed)
 * @param {number} params.limit - Number of records per page
 * @returns {Promise<object>} Timesheet data
 */
export const getEmployeeTimesheet = async (userId, params) => {
  const queryParams = new URLSearchParams();

  if (params.startDate) {
    queryParams.append("startDate", params.startDate);
  }

  if (params.endDate) {
    queryParams.append("endDate", params.endDate);
  }

  if (params.filterMissedShiftsOnly) {
    queryParams.append("filterMissedShiftsOnly", "true");
  }

  if (params.page !== undefined) {
    queryParams.append("page", params.page);
  }

  if (params.limit) {
    queryParams.append("limit", params.limit);
  }

  queryParams.append("type", "json");

  const { payload } = await getRequest(`${baseUrl}/timesheet/${userId}?${queryParams.toString()}`);
  return payload;
};

/**
 * @param {string} timesheetId
 * @returns {Promise<object>}
 */
export const getTimesheetDetailsById = async (timesheetId) => {
  const { payload } = await getRequest(`${baseUrl}/timesheets/${timesheetId}`);
  return payload;
};

/**
 * @param {string} timesheetId
 * @returns {Promise<object>}
 */
export const updateTimeSheetById = async (timeSheetId, body, version = "") => {
  const path = timeSheetId ? `${version}timesheets/${timeSheetId}` : `${version}timesheets`;

  return await patchRequest({
    path,
    body,
    stringifyBody: true,
  });
};

/**
 * @param {string} userId - The employee user ID
 * @param {object} params - Query parameters
 * @param {string} params.startDate - Start date in YYYY-MM-DD format
 * @param {string} params.endDate - End date in YYYY-MM-DD format
 * @param {boolean} params.filterMissedShiftsOnly - Optional filter for missed shifts only
 * @returns {Promise<Blob>} CSV file blob
 */
export const exportEmployeeTimesheetCSV = async (userId, params) => {
  const queryParams = new URLSearchParams();

  if (params.startDate) {
    queryParams.append("startDate", params.startDate);
  }

  if (params.endDate) {
    queryParams.append("endDate", params.endDate);
  }

  if (params.filterMissedShiftsOnly) {
    queryParams.append("filterMissedShiftsOnly", "true");
  } else {
    queryParams.append("filterMissedShiftsOnly", "false");
  }

  queryParams.append("type", "csv");

  const { payload } = await getRequest(`${baseUrl}/timesheet/${userId}?${queryParams.toString()}`, false, "blob");
  return payload;
};
